import { defineComponent, createElementBlock, openBlock, normalizeStyle, Fragment, renderList, createBlock, resolveDynamicComponent, mergeProps, withCtx, createElementVNode, createCommentVNode, normalizeClass, toDisplayString } from "vue";
const _hoisted_1 = { class: "flex items-center gap-2" };
const _hoisted_2 = { key: 0 };
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "p-tabs",
  props: {
    tabs: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      required: true
    },
    tabsLeftPadding: {
      type: Number,
      default: 0
    }
  },
  emits: ["click:tab"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "flex gap-4 border-b border-p-gray-30 text-base font-semibold",
        style: normalizeStyle({ paddingLeft: `${__props.tabsLeftPadding}px` })
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(__props.tabs, (tabData) => {
          return openBlock(), createBlock(resolveDynamicComponent(tabData.to ? "RouterLink" : "div"), mergeProps({
            key: `tab-${tabData.name}`,
            ref_for: true
          }, tabData.to ? { to: tabData.to } : {}, {
            class: [[__props.activeTab === tabData.name ? "border-primary text-primary" : "border-transparent text-p-gray-40"], "group cursor-pointer border-b-2 pb-3 hover:border-primary hover:text-primary"],
            onClick: ($event) => _ctx.$emit("click:tab", tabData.name)
          }), {
            default: withCtx(() => [
              createElementVNode("div", _hoisted_1, [
                tabData.icon ? (openBlock(), createElementBlock("div", _hoisted_2, [
                  (openBlock(), createBlock(resolveDynamicComponent(tabData.icon), {
                    class: normalizeClass(["group-hover:fill-primary", [__props.activeTab === tabData.name ? "fill-primary" : "fill-p-gray-40"]])
                  }, null, 8, ["class"]))
                ])) : createCommentVNode("", true),
                createElementVNode("div", null, toDisplayString(tabData.title), 1)
              ])
            ]),
            _: 2
          }, 1040, ["class", "onClick"]);
        }), 128))
      ], 4);
    };
  }
});
export {
  _sfc_main as _
};
